module.exports = __webpack_public_path__ + "static/media/FinkHeavyRegular.d2740563.woff";